import React from 'react'
import logo from "../assets/financial-breed-images/footer-logo.png"

function Footer() {
    return (
        <>
            <section className='footer'>
                    <div className="row p-5 m-0 justify-content-center">
                        <div className="col-lg-4 col-md-4 col-sm-4 logo">
                            <img src={logo} alt="logo" className='img-fluid' />
                            <div className="col-lg-12">
                                <div className="footer-content">
                                    Employee Retention Tax Credit
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-4">
                            <div className="col-lg-12">
                                <div className="footer-content a23">
                                    <div className='ui7'>
                                        <a href="">Privacy Policy</a>
                                        <a href="">Terms and Conditions</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-4">
                            <div className="col-lg-12">
                                <div className="footer-content">
                                    <p>All rights reserved</p>
                                </div>
                            </div>
                        </div>
                    </div>
            </section>
        </>
    )
}

export default Footer
